/**
 * The API's liveness probe (M1-29). Reuses `GET /health` — same API, same
 * verification as the customer app's `lib/health.ts`: `UseCors` is global
 * middleware ahead of the health-check route, and `TenantResolutionMiddleware`
 * is a no-op for an unauthenticated request, so an anonymous poll reaches it
 * cleanly. Excluded from the OpenAPI spec, so this is a raw `fetch`, not
 * `apiClient`.
 *
 * Polled REACTIVELY only (once a real request has already failed — see
 * `lib/maintenance.ts`), never on a standing interval, so a healthy system
 * pays nothing extra for this feature.
 */
const baseUrl = import.meta.env.VITE_API_BASE_URL || window.location.origin;

export async function checkHealth(): Promise<boolean> {
  try {
    const response = await fetch(new URL('/health', baseUrl), {
      cache: 'no-store',
      credentials: 'omit',
    });
    return response.ok;
  } catch {
    return false;
  }
}
